module.exports = __webpack_public_path__ + "static/media/ic_cc.0533b10d.svg";